import { type ComponentType } from 'react';
import {
  Blue500,
  Green600,
  Mint700,
  Pink400,
  Purple500,
  Yellow700,
} from '@zep-us/zus/tokens';
import { OrderIcon, TextLongLeftIcon } from '@zep-us/zus-icons';

import {
  CheckSmallCircleFillIcon,
  MessageLinesFillIcon,
  SquareGridSemiFillIcon,
} from '@/icons';
import { LocalizedOxTypeIcon } from '@/shared/components/LocalizedOxTypeIcon';
import { type QuizType } from '@/views/build/components/type';

type QuizTypePreviewIcon = ComponentType<{ size?: 'sm'; fill?: string }>;

/** 유형을 추가하면 여기 한 항목과 촬영 스토리 하나를 더한다 */
export const QUIZ_TYPE_PREVIEWS = {
  multiple: {
    Icon: CheckSmallCircleFillIcon,
    iconColor: Green600,
    labelKey: 'common:quizCard.typeBadge.multiple',
    descriptionKey: 'build:typePreview.multiple.description',
    useCaseKeys: [
      'build:typePreview.multiple.useCase.conceptCheck',
      'build:typePreview.multiple.useCase.quickGrading',
    ],
  },
  subjective: {
    Icon: MessageLinesFillIcon,
    iconColor: Blue500,
    labelKey: 'common:quizCard.typeBadge.subjective',
    descriptionKey: 'build:typePreview.subjective.description',
    useCaseKeys: [
      'build:typePreview.subjective.useCase.termRecall',
      'build:typePreview.subjective.useCase.spellingCheck',
    ],
  },
  ox: {
    Icon: LocalizedOxTypeIcon,
    iconColor: Purple500,
    labelKey: 'common:quizCard.typeBadge.ox',
    descriptionKey: 'build:typePreview.ox.description',
    useCaseKeys: [
      'build:typePreview.ox.useCase.warmUp',
      'build:typePreview.ox.useCase.misconceptionCheck',
    ],
  },
  essay: {
    Icon: TextLongLeftIcon,
    iconColor: Pink400,
    labelKey: 'common:quizCard.typeBadge.essay',
    descriptionKey: 'build:typePreview.essay.description',
    useCaseKeys: [
      'build:typePreview.essay.useCase.expressThoughts',
      'build:typePreview.essay.useCase.comprehensionCheck',
    ],
  },
  match: {
    Icon: SquareGridSemiFillIcon,
    iconColor: Yellow700,
    labelKey: 'common:quizCard.typeBadge.match',
    descriptionKey: 'build:typePreview.match.description',
    useCaseKeys: [
      'build:typePreview.match.useCase.conceptLink',
      'build:typePreview.match.useCase.wordMeaning',
    ],
  },
  order: {
    Icon: OrderIcon,
    iconColor: Mint700,
    labelKey: 'common:quizCard.typeBadge.order',
    descriptionKey: 'build:typePreview.order.description',
    useCaseKeys: [
      'build:typePreview.order.useCase.process',
      'build:typePreview.order.useCase.sequence',
    ],
  },
} as const satisfies Record<
  QuizType,
  {
    Icon: QuizTypePreviewIcon;
    iconColor: string;
    labelKey: string;
    descriptionKey: string;
    useCaseKeys: readonly string[];
  }
>;
